/**
 * External dependencies
 */
import React from 'react';
import classnames from 'classnames';

import './styles.scss'

const FormInputCheckbox = ({ className, label, ...otherProps }) => (
	<label className={classnames(className, 'form-checkbox')}>
		<input {...otherProps} type='checkbox' className={'form-checkbox__input'} />
		<span>{label}</span>
	</label>
);

export default FormInputCheckbox;
